'use client';
function padTime(value) {
  return value < 10 ? `0${value}` : `${value}`;
}

export { padTime };
//# sourceMappingURL=pad-time.mjs.map
